module.exports = __webpack_public_path__ + "img/uncommon_image.d18272c6.png";